// Application Logs API
// Extracted from applicationApi.ts — build logs and service logs fetching.

import { ApplicationEndpoints } from "@generated/application";
import { apiBaseUrls } from "src/platform/constants/shared-constants";
import API from "src/platform/http/shared-http";
import debugLogger from "src/platform/utils/debugLogger";

import type { BuildLogsResult, ServiceLogsResult } from "./IApplicationApi";

export async function getBuildLogs(
  alias: string,
  serviceName?: string,
  options?: { sagaId?: string },
): Promise<BuildLogsResult> {
  const endpoint = ApplicationEndpoints.GET_BUILD_LOGS.replace(
    ":id",
    encodeURIComponent(alias),
  );
  let url = serviceName
    ? `${endpoint}/${encodeURIComponent(serviceName)}`
    : endpoint;

  // Append sagaId query param if provided (for run-scoped log fetching)
  if (options?.sagaId) {
    const separator = url.includes("?") ? "&" : "?";
    url = `${url}${separator}sagaId=${encodeURIComponent(options.sagaId)}`;
  }

  try {
    const api = new API(apiBaseUrls.BACKEND, url);
    return await api.get<BuildLogsResult>();
  } catch (error) {
    debugLogger.error(
      "application-api",
      `Failed to fetch build logs for ${alias}`,
      error,
    );
    return { logs: [], message: "Failed to fetch build logs" };
  }
}

export async function getServiceLogs(
  alias: string,
  serviceName: string,
  options?: { tailLines?: number; sinceSeconds?: number },
): Promise<ServiceLogsResult> {
  const endpoint = ApplicationEndpoints.GET_SERVICE_LOGS.replace(
    ":id",
    encodeURIComponent(alias),
  ).replace(":serviceName", encodeURIComponent(serviceName));

  const url = new URL(endpoint, apiBaseUrls.BACKEND);
  if (options?.tailLines)
    url.searchParams.append("tailLines", String(options.tailLines));
  if (options?.sinceSeconds)
    url.searchParams.append("sinceSeconds", String(options.sinceSeconds));

  try {
    const api = new API(url.origin, url.pathname);
    return await api.get<ServiceLogsResult>();
  } catch (error) {
    debugLogger.error(
      "application-api",
      `Failed to fetch service logs for ${alias}/${serviceName}`,
      error,
    );
    return { serviceName, namespace: "", logs: [] };
  }
}
